/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import objectPath from "object-path";
import {Link, withRouter} from "react-router-dom";
import {useSubheader} from "../../_core/MetronicSubheader";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import {useTranslation} from "react-i18next";
import {sendDataLayer} from "../../../../app/util/tagmanager";

//redux:
import {routesActions} from "../../../../app/redux/Routes/routesRedux";
import {selectAllComponents} from "../../../../app/redux_slices/componentsSlice";

//components:
import {CustomInfoModalWithPagination, CustomTooltip} from "../../../../app/widgets";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import {updateParameters} from "../../../../app/redux_slices/userParametersSlice";
import VisibilityIcon from '@material-ui/icons/Visibility';


export const SubHeader = withRouter(props => {
    const {location, history} = props;
    const {t} = useTranslation();

    const uiService = useHtmlClassService();
    const subheader = useSubheader();
    const numberInUrl = location.pathname.match(/\d+/) && location.pathname.match(/\d+/)[0];

    const [isTourOpen, setIsTourOpen] = useState(false);
    const [showGoBack, setShowGoBack] = useState(false);

    const {isHome, isTrackPage, isVideoPage, isReviewPage} = useSelector(state => state.layout);

    //redux:
    //actions:
    const dispatch = useDispatch();
    const setLastPath = path => dispatch(routesActions.setLastPath(path));
    const {showResults} = useSelector(state => state.query);
    //store:
    const contextSelector = useSelector(state => state.context);
    const lastPath = useSelector(state => state.routes.lastPath);
    const components = useSelector(selectAllComponents);
    const credentialSelector = useSelector(state => state.context.credential);

    const hasTopBanner = components && components.find(c => c.parameters.find(param => param.key === "style"));

    useEffect(() => {
        if ((isTrackPage && !credentialSelector.tours?.track) || location.hash.includes("tour")) {
            setIsTourOpen(true);
            setIsTourOpen(true);
            dispatch(updateParameters({values: {tours: {...(credentialSelector.tours ?? {}), track: true}}}));
        }
    }, []);

    const handleGoBack = () => {
        sendDataLayer(
            {
                event: "video_info_go_back",
            },
            {context: contextSelector},
        );
        history.goBack();
    };

    const layoutProps = useMemo(() => {
        return {
            config: uiService.config,
            subheaderMobileToggle: objectPath.get(uiService.config, "subheader.mobile-toggle"),
            subheaderCssClasses: uiService.getClasses("subheader", true),
            subheaderContainerCssClasses: uiService.getClasses("subheader_container", true),
        };
    }, [uiService]);

    useEffect(() => {
        //go back button:
        setShowGoBack(lastPath && lastPath !== location.pathname);
        lastPath !== location.pathname && setLastPath(location.pathname);

        //reset page title:
        if (subheader.title !== "") subheader.setTitle("");
        if (subheader.subTitle !== "") subheader.setSubTitle("");

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);
    const steps = [
        {
            selector: ".trackExplore.d-flex",
            content: t("TOURS.KMAP.1"),
        },
        {
            selector: ".filter_container.firstFilter .list .show_list",
            content: t("TOURS.KMAP.2"),
            action: node => {
                const button = document.querySelectorAll(".filter_container.firstFilter .list .cursor-pointer");
                console.log(button[0])
                if (button[0]) button[0].click();
            },
},
        {
            selector: ".filter_container.firstFilter",
            content: t("TOURS.KMAP.3"),
        },
        {
            selector: ".filter_container.firstFilter",
            content: t("TOURS.KMAP.4"),
        },
        {
            selector: ".filter_container.secondFilter",
            content: t("TOURS.KMAP.5"),
        },
        {
            selector: ".filter_container.thirdFilter",
            content: t("TOURS.KMAP.6"),
        },
        {
            selector: ".filter_container.firstFilter",
            content: t("TOURS.KMAP.7"),
        },
        {
            selector: ".filter_container.secondFilter",
            content: t("TOURS.KMAP.8"),
        },
        {
            selector: ".filter_container.thirdFilter",
            content: t("TOURS.KMAP.9"),
        },
        {
            selector: ".tour-trackbutton",
            content: t("TOURS.KMAP.10"),
        },

        // ...
    ];
    return (
        <div id="kt_subheader" className={`subheader pt-2 m-0 ${layoutProps.subheaderCssClasses}`}>
            <div
                className={`${layoutProps.subheaderContainerCssClasses} d-flex justify-content-between flex-column`}
                style={{
                    height: isHome && !hasTopBanner ? "155px" : "",
                }}
            >
                {/*Mobile Toggle */}
                {layoutProps.subheaderMobileToggle && (
                    <div className="d-flex align-items-center flex-wrap">
                        <button
                            className="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none"
                            id="kt_subheader_mobile_toggle"
                        >
                            <span />
                        </button>
                    </div>
                )}
                <div className="subheader_content">
                    <div className="d-flex align-items-center">
                        <div className="d-flex flex-column">
                            <div className="d-flex align-items-center">
                                <h3
                                    className="subheader_title elipsis_2lines"
                                    dangerouslySetInnerHTML={{__html: subheader.title}}
                                />
                                {isTrackPage && !showResults ? (
                                    <CustomTooltip
                                        config={{
                                            text: "Know more...",
                                            placement: "top",
                                        }}
                                    >
                                        <div
                                            className="d-none d-md-flex pulse pulse-white h-50px w-50px align-items-center justify-content-center cursor-pointer font-size-md"
                                            // onClick={() => setIsTourOpen(true)}
                                            onClick={() => setIsTourOpen(true)}
                                        >
                                            <HelpOutlineIcon className="text-muted text-hover-white" fontSize="large" />
                                            <span className="pulse-ring text-white" />
                                        </div>
                                    </CustomTooltip>
                                ) : null}
                            </div>
                            <h6 className="text-white mb-3" dangerouslySetInnerHTML={{__html: subheader.subTitle}} />
                        </div>
                        <div className="subheader_right_buttons">
                            {(isVideoPage || isReviewPage || isTrackPage) && showGoBack ? (
                                <button className="btn btn-transparent-white" onClick={handleGoBack}>
                                    <span className="menu-text">{t("HEADER.BUTTON.GO_BACK")}</span>
                                </button>
                            ) : null}
                            {numberInUrl && isReviewPage ? (
                                <CustomTooltip
                                        config={{
                                            text: t("HEADER.BUTTON.VIEW"),
                                            placement: "top",
                                        }}
                                    >
                                    <Link className="btn btn-transparent-white" to={`/media/${numberInUrl}`}>
                                        <VisibilityIcon /> 
                                    </Link>
                                </CustomTooltip>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
            {isTourOpen ? (
                <CustomInfoModalWithPagination type="netgraph-trackpage" open={isTourOpen} setOpen={setIsTourOpen} />
            ) : null}
            {/*<Tour*/}
            {/*    steps={steps}*/}
            {/*    isOpen={isTourOpen}*/}
            {/*    onRequestClose={() => setIsTourOpen(false)}*/}
            {/*    onAfterOpen={target => disableBodyScroll(target)}*/}
            {/*    onBeforeClose={target => enableBodyScroll(target)}*/}
            {/*    scrollDuration={100}*/}
            {/*    rounded={15}*/}
            {/*    disableInteraction={true}*/}
            {/*    closeWithMask={false}*/}
            {/*    // lastStepNextButton={<button className={"btn btn-primary"} onClick={() => {*/}
            {/*    //     // const firstTrack = tracks[0].track_id;*/}
            {/*    //     // history.push(`/track/${firstTrack}#tour`);*/}
            {/*    // }}>Preview</button>}*/}
            {/*/>*/}
        </div>
    );
});
